import React from 'react';
import '../css/Ourfleet.css';
import { Helmet } from 'react-helmet';

const Ourfleet = () => {
  const bookingData = [
    {
      id: 1,
      imgSrc: '/images/ourfleet/1.jpg',
      title: 'Swift Desire',
      description: 'Ideal for city rides and short trips, Swift Desire by Skyline Cabs ensures a comfortable, efficient, and budget-friendly travel experience for individuals or small families.',
    },
    {
      id: 2,
      imgSrc: '/images/ourfleet/8.jpg',
      title: 'Aura',
      description: 'With spacious interiors and smooth handling, the Ertiga is perfect for family outings and weekend getaways. Skyline Cabs offers a reliable and cozy ride for your loved ones.',
    },
    {
      id: 2,
      imgSrc: '/images/ourfleet/2.jpg',
      title: 'Ertiga',
      description: 'With spacious interiors and smooth handling, the Ertiga is perfect for family outings and weekend getaways. Skyline Cabs offers a reliable and cozy ride for your loved ones.',
    },
    {
      id: 3,
      imgSrc: '/images/ourfleet/3.jpg',
      title: 'Innova Crysta',
      description: 'Experience luxury and performance with the Innova Crysta. Skyline Cabs provides premium travel for business trips, airport transfers, or long-distance journeys.',
    },
    {
      id: 4,
      imgSrc: '/images/ourfleet/4.jpg',
      title: 'Kia Carens',
      description: 'A blend of style and space, Kia Carens from Skyline Cabs offers a smooth and refined ride, making it ideal for group travels, road trips, or executive transfers.',
    },
    {
      id: 5,
      imgSrc: '/images/ourfleet/5.jpg',
      title: 'Innova Cab',
      description: 'Designed for group comfort, the Innova Cab is perfect for longer trips, family functions, and tours. Skyline Cabs ensures safety and luxury on every mile.',
    },
    {
      id: 7,
      imgSrc: '/images/ourfleet/6.jpg',
      title: 'Tempo Traveller',
      description: 'For mid-sized groups, our Tempo Traveller provides ample legroom, comfort, and convenience. Skyline Cabs makes group outings, pilgrimages, and tours effortless.',
    },
    {
      id: 8,
      imgSrc: '/images/ourfleet/9.webp',
      title: 'Mini Bus',
      description: 'Skyline Cabs’ Mini Bus is perfect for team outings, weddings, and city tours. With spacious seating and clean interiors, it ensures a smooth group travel experience.',
    },
    {
      id: 9,
      imgSrc: '/images/ourfleet/7.jpg',
      title: 'Luxury Bus',
      description: 'Enjoy the pinnacle of comfort with our Luxury Bus. Skyline Cabs offers plush seating, air conditioning, and modern features for premium group transportation.',
    },
  
  ];
  


  return (
    <div>


<section
    className="bg-cover position-relative"
    style={{
      background: 'url(/img/bg-title.jpg) no-repeat',
    }}
    data-overlay="5"
  >
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-xl-7 col-lg-9 col-md-12">
          <div className="fpc-capstion text-center my-4">
            <div className="fpc-captions">
              <h1 className="xl-heading text-light"> Our fleets</h1>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
      





      <section className="our-booking">
        <div className="container">
          {/* <h2 className='section-title'>Explore Our Fleet</h2> */}
          <div className="row g-4">
            {bookingData.map(booking => (
              <div key={booking.id} className="col-12 col-md-6 col-lg-4">
                <div className="card booking-card">
                  <div className="card-image">
                    <img src={booking.imgSrc} className="card-img-top" alt={booking.title} />
                  </div>
                  <div className="card-content">
                    <div className="content-border">
                      <h3 className="card-title">{booking.title}</h3>
                      <p className="card-description text-white">{booking.description}</p>
                      <a href="https://wa.me/917620911746" target="_blank" rel="noopener noreferrer">
    {/* <button className="btn btn-primary">Book Now</button> */}
</a>

                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ourfleet;
